import { useState, useRef } from "react";
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Button,
  FormHelperText,
} from "@chakra-ui/react";
import { useIntl } from "react-intl";

function CustomFileInput({ label, id, placeholder, name, required, helper }) {
  const [selectedFileName, setSelectedFileName] = useState("");
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFileName(file ? file.name : "");
  };

  const handleBrowseClick = () => {
    fileInputRef.current.click();
  };

  const { sav_form } = useIntl().messages;

  return (
    <FormControl>
      <FormLabel htmlFor={id}>{label}</FormLabel>
      <Box position="relative" onClick={handleBrowseClick}>
        <Input
          type="file"
          id={id}
          name={name}
          accept="image/*,.pdf"
          onChange={handleFileChange}
          style={{
            opacity: 0,
            position: "absolute",
            width: "100%",
            height: "100%",
            left: 0,
            top: 0,
          }}
          ref={fileInputRef}
          required={required}
        />
        <Input
          type="text"
          value={selectedFileName}
          readOnly
          placeholder={placeholder}
          cursor="pointer"
          pl={140}
        />
        <Button
          size="md"
          position="absolute"
          left="0"
          top="0"
          height="100%"
          fontWeight="normal"
          variant="input"
        >
          {sav_form.file_upload}
        </Button>
      </Box>
      {helper && <FormHelperText>{helper}</FormHelperText>}
    </FormControl>
  );
}

export default CustomFileInput;
